import { useEffect, useState } from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core';

/** Commit matchMedia result only after it stays unchanged for `delayMs` (avoids false flips after print / viewport glitches). */
function useStableBoolean(value: boolean, delayMs: number): boolean {
  const [stable, setStable] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setStable(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);
  return stable;
}

const MATCH_STABLE_MS = 100;

export const useDeviceData = () => {
  const theme = useTheme();
  const rawSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const rawSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const rawMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const rawLargeDesktop = useMediaQuery('(min-width:1440px)');

  const isMobile = useStableBoolean(rawSmDown, MATCH_STABLE_MS);
  const isDesktop = useStableBoolean(rawMdUp, MATCH_STABLE_MS);
  const isLargeDesktop = useStableBoolean(rawLargeDesktop, MATCH_STABLE_MS);
  /** Derive from stable `isDesktop` so sm–md zone does not disagree with desktop during matchMedia glitches. */
  const isTablet = rawSmUp && !isDesktop;

  const iOS = (window.process as any)?.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

  return { isMobile, isDesktop, isLargeDesktop, iOS, isTablet };
};
